<template>
  <div id="index">
    <div class="edit-wrapper" style="margin: 0 auto">
        <v-card-title flat>
          <v-btn icon @click="onBack"><v-icon large color="blue">keyboard_arrow_left</v-icon></v-btn>
          <v-spacer></v-spacer><v-chip color="blue" dark>できごと追加</v-chip>
        </v-card-title>
        <div style="margin:10px;padding:5px;border:solid 1px #ccc;border-radius:10px;">
          <h4 v-if="mode==='fromQ'">選択中のお題</h4>
          <h4 v-else>対象の年表</h4>
          <v-list two-line>
            <v-list-tile avatar class="record-wrapper">
              <v-list-tile-avatar tile size="70">
                <v-img :src="chronology.imageUrl" aspect-ratio="1"></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title v-if="mode !== 'fromQ'">
                  <strong>みんなの年表</strong>
                </v-list-tile-sub-title>
                <v-list-tile-title v-html="chronology.title + 'の年表'" class="mincho title"></v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-chip v-if="chronology.comment_count>0" small label outline color="red accent-1">
                    <v-icon small>comment</v-icon>&nbsp;{{chronology.comment_count}}
                  </v-chip>
                  {{text}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </div>
    </div>
      <div v-if="!isLoading" class="edit-wrapper" style="margin: 0 auto">
        <!-- メッセージ -->
        <div v-if="tip.isError" class="errorArea">
          <v-alert
            :value="true"
            type="error"
            outline
          >
            {{tip.errorMessage}}
          </v-alert>
        </div>
        <!-- /メッセージ -->
        <v-card-text>
          <p class="title" style="margin-top:0px;">
            生まれた年
          </p>
          <select class="select-year" v-model="birthYear">
            <option value="">生まれ年選択</option>
            <option v-for="(nen, id) in years" :key="id" :value="id">
              {{nen}}
            </option>
          </select>
          <p class="title">
            年選択
            <span class="notNull">必須</span>
          </p>
          <select class="select-year" v-model="tip.year">
            <option value="">できごと年選択</option>
            <option v-for="(nen, id) in displayNens" :key="id" :value="id">
              {{nen}}
            </option>
          </select>
          <p class="title"><v-icon>photo</v-icon>イメージ画像</p>
          <input type="file" id="tipImage" style="display: none;" ref="tipImage" v-on:change="onFileChange" mulitple="multiple">
          <div class="postArea" v-if="tipUploadedImageForView==undefined">
            <p class="addBtn">
              <v-btn large color="blue" dark @click="pickImage('tipImage')"><v-icon>add_a_photo</v-icon>&nbsp; 画像を追加する</v-btn>
            </p>
          </div>
          <div v-else style="text-align:center;margin-bottom:16px;">
            <img :src="tipUploadedImageForView" style="max-width:80%;max-heght:300px;">
            <v-btn fab dark small color="primary" @click="clearImage('tipImage')" style="position:relative;right:20px;">
              <v-icon>clear</v-icon>
            </v-btn>
          </div>
          <p class="title">
            <v-icon>edit</v-icon>タイトル
            <span class="notNull">必須</span>
          </p>
          <v-layout class="title-wrapper" row>
            <v-flex xs12>
              <input v-model="tip.title" class="title-text" type="text" placeholder="タイトルをご記入ください。"/>
            </v-flex>
          </v-layout>
          <p class="title"><v-icon>edit</v-icon>コメントなど</p>
          <textarea  v-model="tip.content" placeholder="「できごと」への想いなどご記入ください。" rows="3" class="message"></textarea>
          <p class="title" style="margin-top:20px;"><v-icon>edit</v-icon>Youtube、関連記事</p>
          <v-layout class="title-wrapper" row>
            <v-flex xs12>
              <input v-model="tip.referUrl" class="title-text" type="text" placeholder="Youtubeや元記事のURL"/>
            </v-flex>
          </v-layout>
          <p>Youtubeの動画URLを記入すると年表にYoutubeが埋め込めます。</p>
          <!-- メッセージ -->
          <div v-if="isError" class="errorArea">
            <v-alert
              :value="true"
              type="error"
              outline
              style="margin:10px 0 0 0 "
            >
              {{errorMessage}}
            </v-alert>
          </div>
          <!-- /メッセージ -->
          <v-btn block color="blue" dark large @click="onSave" style="margin-top:20px;margin-bottom:0px;"><v-icon>send</v-icon>&nbsp;投稿する</v-btn>
        </v-card-text>
      </div>
      <v-flex xs12 style="text-align:center;padding-top: 160px;" v-else>
        <v-progress-circular class="isLoading" v-show="isLoading" :size="70" :width="7" color="blue" indeterminate></v-progress-circular>
      </v-flex>
    <!-- ／できごと登録画面 -->
  </div>
</template>

<script>
import { db } from '../main'
import firebase from 'firebase'
var md5 = require('md5')
let fileExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif']
let maxWidth = 600
let maxHeight = 600
var FileUploadThumbnail = require('file-upload-thumbnail')
export default {
  name: 'Index',
  data () {
    return {
      mode: undefined,
      isLoading: false,
      birthYear: '',
      nens: ['平成元年　（1989年）', '平成2年 　（1990年）', '平成3年 　（1991年）', '平成4年 　（1992年）', '平成5年 　（1993年）', '平成6年 　（1994年）', '平成7年 　（1995年）', '平成8年 　（1996年）', '平成9年 　（1997年）', '平成10年　（1998年）', '平成11年　（1999年）', '平成12年　（2000年）', '平成13年　（2001年）', '平成14年　（2002年）', '平成15年　（2003年）', '平成16年　（2004年）', '平成17年　（2005年）', '平成18年　（2006年）', '平成19年　（2007年）', '平成20年　（2008年）', '平成21年　（2009年）', '平成22年　（2010年）', '平成23年　（2011年）', '平成24年　（2012年）', '平成25年　（2013年）', '平成26年　（2014年）', '平成27年　（2015年）', '平成28年　（2016年）', '平成29年　（2017年）', '平成30年　（2018年）', '平成31年　（2019年4月まで）', '令和元年　（2019年5月～）', '令和2年　（2020年）'],
      isError: false,
      timestamp: undefined,
      id: undefined,
      errorMessage: '',
      tipUploadedImageForView: undefined,
      tipUploadedImage: undefined,
      tip: {
        year: '',
        title: '',
        content: '',
        referUrl: ''
      },
      chronology: {},
      years: []
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    },
    displayNens () {
      if (this.birthYear === '') {
        return this.nens
      } else {
        let init = 1989
        let birth = Number(this.years[this.birthYear])
        let displayNens = []
        let num = 0
        for (let i = 0; i < this.nens.length; i++) {
          if (this.nens[i] === '令和元年　（2019年5月～）') num--
          let age = init + num - birth
          let text = this.nens[i] + '　' + age + '歳'
          if (age < 0) text = this.nens[i] + '未誕生'
          displayNens.push(text)
          num++
        }
        return displayNens
      }
    },
    text () {
      if (this.chronology.introduction !== undefined && this.chronology.introduction.length > 1) {
        return this.chronology.introduction
      } else {
        return this.chronology.message
      }
    }
  },
  filters: {
  },
  mounted () {
    this.chronology = this.$route.params.obj.chronology
    this.mode = this.$route.params.obj.mode
    this.id = this.$route.params.obj.id
    if (this.mode === 'new') {
    } else if (this.mode === 'edit') {
      this.tip = this.$route.params.obj.tip
      if (this.tip.image !== undefined) {
        this.tipUploadedImageForView = this.tip.imageUrl
        this.tipUploadedImage = 'saved'
      }
      if (this.tip.birthYear !== undefined) {
        this.birthYear = Number(this.tip.birthYear) - 1950
      }
    } else if (this.mode === 'fromQ') {
    }
    for (let i = 1950; i <= 2018; i++) {
      this.years.push(i)
    }
  },
  methods: {
    onSave () {
      this.tipSave()
    },
    tipSave () {
      let timestamp = new Date()
      let docId = ''
      if (this.tip.id !== undefined) {
        docId = this.tip.id
      } else {
        docId = md5(this.id + timestamp)
      }
      if (!this.validate_tip()) return
      this.isLoading = true
      let saveData = {
        year: this.tip.year,
        title: this.tip.title,
        content: this.tip.content,
        referUrl: this.tip.referUrl,
        uid: firebase.auth().currentUser.uid,
        displayName: this.$store.state.view.displayName,
        profileImageUrl: this.$store.state.view.profileImageUrl,
        timestamp: timestamp
      }
      if (this.birthYear !== '') {
        saveData.birthYear = Number(this.birthYear) + 1950
      }
      // image
      if (this.tipUploadedImage !== undefined && this.tipUploadedImage !== 'saved') {
        let fname = `${docId}.png`
        saveData.image = fname
        if (this.tipUploadedImage !== 'saved') {
          let storageRef = firebase.storage().ref()
          let imageRef = storageRef.child('chronology/' + this.id + '/' + fname)
          imageRef.put(this.tipUploadedImage).then((snapshot) => {
          })
        }
      } else if (this.tipUploadedImage === 'saved' && this.tip.image !== undefined) {
        saveData.image = this.tip.image
      } else if (this.tipUploadedImage === undefined || this.tip.image === undefined) {
      }
      db.collection('chronology').doc(this.id).collection('tips').doc(docId).set(saveData)
        .then(function () {
          if (this.tipUploadedImage !== undefined && this.tipUploadedImage !== 'saved') {
            setTimeout(this.tipSaveFini, 2000)
          } else {
            this.tipSaveFini()
          }
        }.bind(this))
        .catch(function (error) {
          alert('エラーです。申し訳ございません。\r\n再度保存をお願いいたします。')
          console.error(error)
          this.isLoading = false
        }.bind(this))
    },
    tipSaveFini () {
      alert('できごとを登録しました。')
      this.isLoading = false
      this.$router.push({name: 'Chronology', params: {id: this.id}})
    },
    pickImage (refname) {
      this.$refs[refname].click()
    },
    onFileChange (e) {
      let tagId = e.target.id
      let files = e.target.files || e.dataTransfer.files
      // ファイルのチェック
      // ファイルタイプ
      var myFileType = files[0].type
      var fileTypeCheck = false
      for (var i = 0; i < fileExtensions.length; i++) {
        var fileExtension = fileExtensions[i]
        if (myFileType.indexOf(fileExtension) > -1) {
          fileTypeCheck = true
          break
        }
      }
      if (!fileTypeCheck) {
        if (tagId === 'topImage') {
          this.isError = true
          this.errorMessage = 'アップロードできるファイルは画像のみです。'
        } else {
          this.tip.isError = true
          this.tip.errorMessage = 'アップロードできるファイルは画像のみです。'
        }
        return
      }
      new FileUploadThumbnail({
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        file: files[0],
        onSuccess: function (src) {
          this.tipUploadedImageForView = src
          // base64 => blob
          let barr, bin, i, len
          bin = atob(src.split('base64,')[1])
          len = bin.length
          barr = new Uint8Array(len)
          i = 0
          while (i < len) {
            barr[i] = bin.charCodeAt(i)
            i++
          }
          let blob = new Blob([barr], {type: 'image/jpeg'})
          this.tipUploadedImage = blob
        }.bind(this)
      }).createThumbnail()
    },
    clearImage (target) {
      this.tipUploadedImageForView = undefined
      this.tipUploadedImage = undefined
    },
    validate_tip () {
      this.isError = false
      this.errorMessage = ''
      if (this.tip.year === '') {
        this.isError = true
        this.errorMessage = '年を選択してください。'
        return false
      }
      if (this.tip.title.length < 1) {
        this.isError = true
        this.errorMessage = 'タイトルは1文字以上入力してください。'
        return false
      }
      if (this.tip.title.length > 100) {
        this.isError = true
        this.errorMessage = 'タイトルは最大100文字までです。'
        return false
      }
      if (this.tip.content > 1000) {
        this.isError = true
        this.errorMessage = '自由記入欄は最大1000文字です。'
        return false
      }
      return true
    },
    onBack () {
      if (this.mode === 'fromQ') {
        this.$router.push({name: 'QList'})
      } else {
        this.$router.push({name: 'Chronology', params: {id: this.id}})
      }
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
ul{
  padding-left: 0 !important;
}
li{
  list-style: none;
}
.edit-wrapper{
  width: 100%;
  max-width: 700px;
  margin: 36px auto;
  padding: 0 10px;
}
.errorArea{
  width: 100%;
  max-width: 700px;
  margin: 0px auto;
}
.postArea{
   background-color:rgba(0,0,1,0.05);
   background-image: url('../assets/image/dot120clear256.png');
   background-repeat:repeat;
   width: 100%;
}
.addBtn{
  padding: 40px 0;
  text-align: center;

}
p.title{
  margin-top: 30px;
  margin-bottom: 5px;
}
.title-wrapper{
  margin-bottom:16px;
}
.title-text{
  border: solid 1px #9f9f9f;
  border-radius: 5px;
  width: 100%;
  height: 50px;
  padding-left: 5px;
  font-size: 110%;
}
.select-year{
  border: solid 1px #9f9f9f;
  width: 100%;
  height: 50px;
  border-radius: 5px;
  padding-left: 15px;
  font-size: 110%;
  -webkit-appearance:menulist-button !important;
  -moz-appearance:menulist-button !important;
}
textarea{
  border-bottom: solid 1px #9f9f9f;
  border-top: solid 1px #9f9f9f;
  border-right: solid 1px #9f9f9f;
  width: 100%;
  height: 40px;
  padding-left: 5px;
  font-size: 110%;
}
.message{
  border: solid 1px #9f9f9f;
  border-radius: 5px;
  width: 100%;
  height: 100px;
  padding-left: 5px;
  font-size: 110%;
}
.notNull{
  color:#f44336;
  margin-left: 4px;
  font-size: 90%;
  font-weight: bold;
}
.v-list__tile__avatar {
  min-width:76px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TipAdd.vue